export default "__VITE_ASSET__Dyh0_ApI__"